<template>
    <section>
        <div class="footer">Copyright © 2009-{{new Date().getFullYear()}} 上海数据港股份有限公司 All Rights Reserved.</div>
        <div id="loadingPrompt" hidden  style="position: fixed;left: 0px;top: 0px;width:100%;height:100%;z-index: 10002; opacity:0.4;background-color: #000">
            <div style="position: absolute;left: 45%;top: 40%;opacity:1;">
            <img src="../../assets/images/loading.gif" />
            </div>
        </div>
    </section>
</template>

<script>
  export default {
    name: 'Footer'
  }
</script>
